import { render, staticRenderFns } from "./addTransfer.vue?vue&type=template&id=8d930952&scoped=true&"
import script from "./addTransfer.vue?vue&type=script&lang=js&"
export * from "./addTransfer.vue?vue&type=script&lang=js&"
import style0 from "./addTransfer.vue?vue&type=style&index=0&id=8d930952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d930952",
  null
  
)

export default component.exports